if(!customElements.get("collection-paginate")) {
  customElements.define("collection-paginate", class CollectionPaginate extends HTMLElement {
    constructor() {
      super();

      this.loadingIndicator = this.querySelector(".paginate--loading");
      this.filter = this.closest(".collection-grid-section").querySelector("#main-collection-filters filter-dropdown");
      this.productGrid = this.querySelector("#main-collection-product-grid");
      this.currentPage = parseInt(this.dataset.pageNum);
      this.totalPages = parseInt(this.dataset.pageTotal);
      this.inProgress = false

      if(this.currentPage >= this.totalPages) this.removeLoader.bind(this);
      window.addEventListener("scroll", this.loaderInView.bind(this));
    }

    loaderInView() {
      const viewPosition = window.innerHeight - 50;
      if(this.loadingIndicator) {
        const indicatorBox = this.loadingIndicator.getBoundingClientRect();
        if(!this.inProgress && indicatorBox) {
          if(indicatorBox.bottom <= viewPosition) {
            this.inProgress = true;
            this.getNextContents();
          }
        }
      }
    }

    async getNextContents() {
      try {
        const response = await fetch(`${window.location.pathname}/${this.filter.activeFilters.join("+")}?page=${this.currentPage + 1}`);
        const data = await response.text();

        const paginateHTML = document.createElement("div");
        paginateHTML.innerHTML = data;
        const newCollectionPaginate = paginateHTML.querySelector("collection-paginate");

        this.productGrid.innerHTML += newCollectionPaginate.productGrid.innerHTML;

        // update currentpage index
        this.currentPage = newCollectionPaginate.currentPage;
        // remove loading indicator if all the pages have been loaded
        this.currentPage >= this.totalPages ? this.removeLoader() : "";

  
        // reinit stamped reviews
        stampedInit(window, document);
        
        // end of paginate operation
        this.inProgress = false;
      } catch(err) {
        console.error(err);
      }
    }

    removeLoader() {
      this.loadingIndicator.remove(this.loadingIndicator);
      this.loadingIndicator = null;
    }
  });
}
